// extracted by mini-css-extract-plugin
export default {"overridePatronBlockHeader":"overridePatronBlockHeader---AuW_S","patronBlock":"patronBlock---HjiT9","overridePatronBlock":"overridePatronBlock---smWJ8"};